import { useSelector } from "react-redux";
import classNames from "classnames";
import styles from "./CreditsBadge.module.css";

const selectCredits = (state) => state.credits;

const CreditsBadge = () => {
  const { balance, planType } = useSelector(selectCredits);

  const planLabel = planType === "pro" ? "Pro" : "Free";
  const isPro = planType === "pro";

  return (
    <div className={styles.container}>
      <div className={classNames(styles.badge, { [styles.pro]: isPro })}>
        <svg
          className={styles.icon}
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
            clipRule="evenodd"
          />
        </svg>
        <span className={styles.text}>
          <span className={styles.balance}>{balance}</span>
          <span className={styles.separator}> credits</span>
          <span className={styles.plan}> · {planLabel}</span>
        </span>
      </div>
    </div>
  );
};

export default CreditsBadge;
